import React, { useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { withRouter } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';

//img
import home from '../../assets/icons/home.svg';
import homeContrast from '../../assets/icons/home-white.svg';
import ArrowCircleImg from '../../assets/icons/arrow-circle-empty-medium.svg';
import ArrowCircleImgContrast from '../../assets/icons/arrow-circle-empty-right-contrast.svg';

const ExpandedMenuItem = ( { id, url, title,  }) => (
    <li key={ id } className="header__nav-dropdown__list-item">
        <Link 
            to={ `${url}` }
            className="header__nav-dropdown__list-link"
            title={ title }
            scroll={ el => el.scrollIntoView({ block: 'start' }) }
        >
            { title }
            <span className="header__nav-dropdown__list-link__line"></span>

            <img 
                className="header__nav-dropdown__list-link__img" 
                src={ ArrowCircleImg } 
                alt="" 
            />

            <img 
                className="header__nav-dropdown__list-link__img contrast" 
                src={ ArrowCircleImgContrast }
                alt="" 
            />
        </Link>
    </li>
);


const HeaderNav = ({ clang, data }) => {
    const [openedId, setOpenedId] = React.useState(null);

    const toggleOpened = useCallback((id) => {
        setOpenedId(id);
    }, []);

    const resetOpened = useCallback(() => {
        setOpenedId(null);
    }, []);

    return (
        <ul className="header__nav">
            <li className="header__nav-item">
                <NavLink exact to={ `/` } className="header__nav-img__link" title={ lang[ clang ].home } activeClassName="active">
                    <img className="header__nav-img" src={ home } alt={ lang[ clang ].alt.home } />
                    <img className="header__nav-img contrast" src={ homeContrast } alt={ lang[ clang ].alt.home } />
                </NavLink>
            </li>
            { data.map(menuItem =>
                <li key={ menuItem.id } className="header__nav-item"
                    onMouseEnter={ () => toggleOpened(menuItem.id) }
                    onMouseLeave={ () => resetOpened() }>
                    <NavLink 
                        to={ `${menuItem.url}` } 
                        className="header__nav-item__link" 
                        activeClassName="active" 
                        title={ menuItem.title }
                    >
                        { menuItem.title }
                        <span className="header__nav-item__link-circle"></span>
                    </NavLink>
                    { (openedId === menuItem.id && menuItem.children) && (
                        <div className="header__nav-dropdown">
                            <h5 className="header__nav-dropdown__title">
                                { menuItem.title }
                            </h5>
                            <ul className="header__nav-dropdown__list">
                                { menuItem.children.map((child) => (
                                    <ExpandedMenuItem
                                        key={ child.id }
                                        url={ child.url }
                                        title={ child.title } 
                                    />
                                )) }
                            </ul>
                        </div>
                    ) }
                </li>
            ) }
        </ul>
	);
};


HeaderNav.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(HeaderNav));



// WEBPACK FOOTER //
// ./src/components/header/HeaderNav.js